import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader
} from "../../store/actions";
import logo from "../../assets/images/logo.svg";
import logosm from "../../assets/images/logosm.svg";

const SidebarContent = (props) => {
  const { t } = useTranslation();
  const location = useLocation();

  const [openMenus, setOpenMenus] = useState({
    checklist: false,
    users: false,
    transactions: false
  });

  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const role = Number(authUser?.user?.role);
      setIsAdmin(role === 1);
    } catch {
      setIsAdmin(false);
    }
  }, []);

  useEffect(() => {
    // Auto-open the correct submenu based on current path
    const path = location.pathname;
    setOpenMenus({
      checklist: path.startsWith("/saleslist") || path.startsWith("/add-saleslist"),
      users: path.startsWith("/users") || path.startsWith("/add-users"),
      transactions: path.startsWith("/transactions") || path.startsWith("/add-transaction")
    });
  }, [location.pathname]);

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const isActive = (path) => location.pathname === path;
  const isActiveMultiple = (paths) => paths.includes(location.pathname);

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <div className="navbar-brand-box py-3 pt-0">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logosm} alt="Logo" height="32" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="Logo" height="32" />
            </span>
          </Link>
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logosm} alt="Logo" height="32" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="Logo" height="32" />
            </span>
          </Link>
        </div>

        <ul className="metismenu list-unstyled" id="side-menu">
          <li className={isActive("/") ? "mm-active" : ""}>
            <Link to="/" className={`menuitem waves-effect ${isActive("/") ? "active" : ""}`}>
              <i className="ri-dashboard-fill"></i>
              <span className="ms-1">{t("Dashboard")}</span>
            </Link>
          </li>
          <li className={isActive("/saleslist") ? "mm-active" : ""}>
            <Link to="/saleslist" className={`menuitem ${isActive("/saleslist") ? "active" : ""}`}>
              <i className="mdi-store mdi"></i>
              <span className="ms-1">{t("Sales list")}</span>
            </Link>
          </li>
          <li className={isActive("/calendar") ? "mm-active" : ""}>
            <Link to="/calendar" className={`menuitem ${isActive("/calendar") ? "active" : ""}`}>
              <i className="mdi mdi-calendar"></i>
              <span className="ms-1">{t("Calendar")}</span>
            </Link>
          </li>
          {isAdmin && (
            <li className={isActiveMultiple(["/users", "/add-users"]) ? "mm-active" : ""}>
              <a
                href="#usersSubmenu"
                className={`menuitem has-arrow waves-effect ${isActiveMultiple(["/users", "/add-users"]) ? "active" : ""}`}
                onClick={e => { e.preventDefault(); toggleMenu("users"); }}
                aria-expanded={openMenus.users}
              >
                <i className="mdi mdi-account-multiple"></i>
                <span className="ms-1">{t("Users")}</span>
              </a>
              <ul className={`sub-menu${openMenus.users ? " show" : ""}`}>
                <li className={isActive("/users") ? "mm-active" : ""}>
                  <Link to="/users" className={`menuitem ${isActive("/users") ? "active" : ""}`}>
                    {t("View Users")}
                  </Link>
                </li>
                <li className={isActive("/add-users") ? "mm-active" : ""}>
                  <Link to="/add-users" className={`menuitem ${isActive("/add-users") ? "active" : ""}`}>
                    {t("Add User")}
                  </Link>
                </li>
              </ul>
            </li>
          )}
          <li className={isActiveMultiple(["/transactions", "/add-transaction"]) ? "mm-active" : ""}>
            <a
              href="#transactionsSubmenu"
              className={`menuitem has-arrow waves-effect ${isActiveMultiple(["/transactions", "/add-transaction"]) ? "active" : ""}`}
              onClick={e => { e.preventDefault(); toggleMenu("transactions"); }}
              aria-expanded={openMenus.transactions}
            >
              <i className="mdi mdi-bank"></i>
              <span className="ms-1">{t("Transactions")}</span>
            </a>
            <ul className={`sub-menu${openMenus.transactions ? " show" : ""}`}>
              <li className={isActive("/transactions") ? "mm-active" : ""}>
                <Link to="/transactions" className={`menuitem ${isActive("/transactions") ? "active" : ""}`}>
                  {t("View")}
                </Link>
              </li>
              <li className={isActive("/add-transaction") ? "mm-active" : ""}>
                <Link to="/add-transaction" className={`menuitem ${isActive("/add-transaction") ? "active" : ""}`}>
                  {t("Add Transaction")}
                </Link>
              </li>
            </ul>
          </li>
          <li className={isActive("/profile") ? "mm-active" : ""}>
            <Link to="/profile" className={`menuitem ${isActive("/profile") ? "active" : ""}`}>
              <i className="mdi mdi-account-circle"></i>
              <span className="ms-1">{t("Profile")}</span>
            </Link>
          </li>
          <li className={isActive("/accountant-history") ? "mm-active" : ""}>
            <Link to="/accountant-history" className={`menuitem ${isActive("/accountant-history") ? "active" : ""}`}>
              <i className="mdi mdi-history"></i>
              <span className="ms-1">{t("Accountant history")}</span>
            </Link>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  ...state.Layout,
});

export default connect(mapStateToProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeLayoutWidth,
  changePreloader,
})(SidebarContent);